import React from "react";
import { useHistory } from "react-router-dom";
import MUIButton from "@mui/material/Button";
import MUIAddIcon from "@mui/icons-material/Add";

import LayerFunctional from "../../../LayerFunctional";
import CardAdminDashboardList from "../../../Component/Card/Admin/Dashboard/CardAdminDashboardList";
import PageHeader from "../../../Component/PageHeader";

export default function AdminDashboardList() {
    const history = useHistory();

    return (
        <LayerFunctional
            getMaxWidth={() => 1000}
            renderHeader={() => {
                const buttons = [
                    (
                        <MUIButton
                            key="create"
                            variant="contained"
                            startIcon={<MUIAddIcon />}
                            onClick={() => history.push("/admin/dashboard")}
                        >
                            Create New
                        </MUIButton>
                    ),
                ];

                return <PageHeader title="Dashboards" buttons={buttons} />;
            }}
            renderContent={() => <CardAdminDashboardList />}
        />
    );
}
